/** createdBy — mismo patrón que createOrder. */
export interface EditAmountCreatedByInput {
  name: string;
  email: string;
}

export type EditServiceAmountScope = 'SINGLE' | 'GROUPED';

export interface EditServiceAmountInput {
  serviceId: string;
  amount: number;
  scope?: EditServiceAmountScope;
  createdBy: EditAmountCreatedByInput;
}

export interface EditTicketAmountInput {
  ticketId: string;
  serviceId: string;
  amount: number;
  createdBy: EditAmountCreatedByInput;
}

export interface EditAmountMoney {
  currency?: string | null;
  amount?: number | null;
  amountSoles?: number | null;
  amountDollars?: number | null;
  exchangeRate?: number | null;
}

export interface EditAmountWarning {
  code?: string | null;
  message?: string | null;
  serviceId?: string | null;
  ticketId?: string | null;
}

/** Snapshot paint-ready de servicio tras edit amount. */
export interface EditAmountServiceSnapshot {
  id: string;
  total?: number | null;
  moneda?: string | null;
  editOperation?: boolean | null;
  newTotalCostoSoles?: number | null;
  newTotalCostoDolares?: number | null;
}

/** Snapshot paint-ready de ticket tras edit amount. */
export interface EditAmountTicketSnapshot {
  id: string;
  total?: number | null;
  moneda?: string | null;
  editOperation?: boolean | null;
  newTotalCostoSoles?: number | null;
  newTotalCostoDolares?: number | null;
}

export interface EditAmountResult {
  ok: boolean;
  serviceId?: string | null;
  ticketId?: string | null;
  updatedServiceIds?: string[] | null;
  money?: EditAmountMoney | null;
  serviceTotal?: EditAmountMoney | null;
  itineraryId?: string | null;
  itineraryCostDeltaDollars?: number | null;
  warnings?: EditAmountWarning[] | null;
  services?: EditAmountServiceSnapshot[] | null;
  ticket?: EditAmountTicketSnapshot | null;
}

/** Resultado al cerrar dialogs de editar monto. */
export interface EditAmountDialogCloseResult {
  success: boolean;
  result?: EditAmountResult | null;
  /** OS / race: el padre puede deshabilitar CTA. */
  blockedByOrder?: boolean;
}

export function isGroupedAmountScopeAllowed(
  tipoServicio: string | null | undefined
): boolean {
  const tipo = String(tipoServicio ?? '')
    .trim()
    .toUpperCase();
  return tipo === 'PERSONALDECAMPO' || tipo === 'GUIA';
}
